export default __webpack_public_path__ + "static/media/map-pin-location-yesterday.1d89c256.svg";